"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var base_1 = require("@bhtp-client-api/base");
var BillingFormInfo = (function (_super) {
    __extends(BillingFormInfo, _super);
    function BillingFormInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BillingFormInfo.toApiPaymentInformation = function (billingInformation, merchantProfile, paymentMethod) {
        var paymentInfo = new base_1.ApiPaymentInformation();
        paymentInfo.address = billingInformation.address1;
        paymentInfo.city = billingInformation.city;
        paymentInfo.customerId = billingInformation.customerId;
        paymentInfo.isTest = false;
        paymentInfo.merchantProfile = merchantProfile;
        paymentInfo.nameOnCard = billingInformation.name;
        paymentInfo.paymentMethod = paymentMethod;
        paymentInfo.state = billingInformation.stateOrProvince;
        paymentInfo.paymentToken = billingInformation.paymentToken;
        paymentInfo.zip = billingInformation.postalCode;
        return paymentInfo;
    };
    BillingFormInfo.valOrEmptyString = function (val) {
        return val || '';
    };
    return BillingFormInfo;
}(base_1.ApiAddress));
exports.BillingFormInfo = BillingFormInfo;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-models/payments/billing-form-info.model.js